import { createStore } from 'vuex'

export default createStore({
  state: {
    authorization: localStorage.getItem("token"),
    name: localStorage.getItem("name"),
    userId: Number(localStorage.getItem("userId")),
    plate: [],
    postList: [] as any[],
    imgToken: "",
  },
  getters: {
    getAuthToken: (state) => {
      return state.authorization
    },
    getName: (state) => {
      return state.name
    },
    getUserId: (state) => {
      return state.userId
    },
    getPlate: (state) => {
      return state.plate
    },
    getPlateName: (state) => (id: number) => {
      for (let i = 0; i < state.plate.length; i++) {
        if (state.plate[i]["id"] == id) {
          return state.plate[i]["name"]
        }
      }
    },
    getPlateData: (state) => (id: number) => {
      for (let i = 0; i < state.plate.length; i++) {
        if (state.plate[i]["id"] == id) {
          return state.plate[i]
        }
      }
      return null
    },
    getPost: (state) => (id: number) => {
      for (let i = 0; i < state.postList.length; i++) {
        if (state.postList[i]["id"] == id) {
          return state.postList[i]
        }
      }
      return null
    },
    getImgToken: (state) => {
      return state.imgToken
    }
  },
  mutations: {
    setAuthToken: (state, token: string) => {
      state.authorization = token
      localStorage.setItem("token", token)
    },
    setName: (state, name: string) => {
      // 写入侧防御：过滤 undefined/null/空，避免把 "undefined" 这类脏值
      // 持久化进 localStorage（user/get 字段大小写不匹配时曾踩过此坑）。
      const safe = (name && name !== "undefined" && name !== "null") ? name : ""
      state.name = safe
      localStorage.setItem("name", safe)
    },
    setUserId: (state, userId: number) => {
      state.userId = Number(userId)
      localStorage.setItem("userId", String(userId))
    },
    setPlate: (state, plate) => {
      state.plate = plate
    },
    addPost: (state, post: Object) => {
      state.postList.push(post)
    },
    setImgToken: (state, token: string) => {
      state.imgToken = token
    }
  },
  actions: {
  },
  modules: {
  }
})
